import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavbarModule } from './navbar/navbar.module';

@NgModule({
    imports: [
        CommonModule,
        NavbarModule
    ],
    exports: [
        NavbarModule
    ]
})
export class CoreModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/core/core.module.ts